<div id="evalualiaReport" *ngIf="test">
  <div class="bg-color-white shadow-lg color-primary body-m">
        <!-- Portada -->
    <ct-cover-page-report [colors]="colors" [reportType]="'consultant'" [test]="test" [currentDate]="currentDate"></ct-cover-page-report>

    <!-- Header -->
    <div id="header" class="d-flex justify-content-between color-tertiary body-s mar-t-3">
      <div>{{ (test.candidate?.name)
        ? (test.candidate | initials)
        : test.candidate.randstadCandidate }} | {{ (test.invitationId != 0 ? test.invitationId : test.externalId) }} | K/01/SP</div>
      <div>{{ currentDate | date:'dd/MM/yyyy' }}</div>
    </div>


    <!-- Contenido del informe -->
    <div class="page">
      <h1 class="color-tertiary title-xl mar-b-3">{{ 'REPORT.EVALUALIA.TITLE1' |translate }} {{ 'REPORT.EVALUALIA.TITLE2'|translate }}</h1>

      <ng-container *ngIf="reportType == 'language'">
        <div class="title-s mar-b-3">{{ 'REPORT.EVALUALIA.FINALSCORE' | translate }}:</div>

        <div id="cards" class="row mar-b-4 title-xs">
          <div class="col-4 pad-x-1">
            <div class="card bg-color-tertiary color-white h-100">
              <div class="card-body pad-1">
                <p>
                  <span>{{ 'REPORT.EVALUALIA.SUCCESSTITLE1' | translate }}</span><br>
                  <span class="color-senary">{{ test.result.score }}%</span><br>
                  <span>{{ 'REPORT.EVALUALIA.SUCCESSTITLE2' | translate }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4 pad-x-1">
            <div class="card bg-color-tertiary color-white h-100">
              <div class="card-body pad-1">
                <p>
                  <span>{{ 'REPORT.EVALUALIA.LEVELACHIEVED' | translate }}</span><br>
                  <span class="color-senary">{{ test.result.levelAchieved }} <span class="color-white">{{ 'COMMON.OF' | translate }}</span> {{ test.result.maxLevel }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4 pad-x-1">
            <div class="card bg-color-tertiary color-white h-100">
              <div class="card-body pad-1">   
                <ng-container *ngIf="test.result.levelAchieved < 2">
                  <p>{{ 'REPORT.EVALUALIA.LEVELDIDNOTREACHED' | translate }}</p>
                  <p class="color-senary"> {{ test.levels[0].description }}</p>
                </ng-container>

                <ng-container *ngIf="test.result.levelAchieved >= 2">
                  <p>
                    <span>{{ 'REPORT.EVALUALIA.YOURFINALSCORE' | translate }} </span>
                    <span>{{ 'REPORT.EVALUALIA.BELONGSGROUP1' | translate }} </span>
                    <span class="color-senary">{{ maxLevelApproved() }} </span>
                    <span>{{ 'REPORT.EVALUALIA.BELONGSGROUP2' | translate }} </span>
                  </p>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <p>{{ 'REPORT.EVALUALIA.LEVELCOMPLETED' | translate:{ a: test.result.timeSpent, b: test.result.completionPercentage } }}</p>   

        <div class="mar-b-4">
          <ng-container *ngFor="let level of test.levels; index as i">
            <div class="row mar-b-1">
              <div class="col-3 align-content-end">{{ 'COMMON.LEVEL' | translate }} {{ level.description }}</div>
              <div class="col-3 align-content-end">{{ level.time | secondsTime }} {{ 'COMMON.OF' | translate }} {{ level.maxDuration | secondsTime }}</div>
              <div class="col-4">
                <div class="mar-b-1" *ngIf="i == 0">{{ 'REPORT.EVALUALIA.COMPLETION' | translate }}</div>
                <div class="d-inline-block w-75" style="vertical-align: middle;">
                  <ngb-progressbar type="primary" [value]="level.completion" height="20px"></ngb-progressbar>
                </div>
                <div class="d-inline-block w-25 text-center">{{ level.completion }}%</div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.AREASCORE' | translate }}:</div>
            <div id="chart">
              <p>{{ 'REPORT.EVALUALIA.SUCCESSPERCENTAGE' | translate }}</p>
              <div id="radarChart">
                <canvas baseChart
                  [data]="radarChartData"
                  [options]="radarChartOptions"
                  type="radar">
                </canvas>
              </div>
            </div>
          </div>
          <div id="results" class="col-6">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.RESULTSREPORT' | translate }}:</div>
              <p>{{ test.result.scoreDetail }}</p>
              <p [innerHTML]="test.result.areaScoreDetail"></p>
          </div>
        </div>
      </ng-container>


      <ng-container *ngIf="reportType == 'typewriting'">
        <div class="title-s mar-b-3">{{ 'REPORT.EVALUALIA.FINALSCORE' | translate }}:</div>
        <div class="row">
          <div class="col-7 mar-b-4">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.AREASCORE' | translate }}:</div>
              <table class="table">
                <tbody>
                  <tr>
                    <td>{{ 'REPORT.EVALUALIA.BEATSPERMINUTEWITHERRORS' | translate }}:</td>
                    <td>{{ test.result.errorsKpm }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'REPORT.EVALUALIA.BEATSPERMINUTE' | translate }}:</td>
                    <td>{{ test.result.kpm }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'REPORT.EVALUALIA.ERRORS' | translate }}:</td>
                    <td>{{ test.result.errorsPercentage }}%</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <div id="results" class="col-12 mar-b-4">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.RESULTSREPORT' | translate }}:</div>
              <p>{{ 'REPORT.EVALUALIA.TYPEWRITING.RESUME1' | translate:{ a: test.result.kpm, b: test.result.errorsPercentage } }}</p>
              <p>{{ 'REPORT.EVALUALIA.TYPEWRITING.RESUME2' | translate:{ a: test.result.errorsKpm } }}</p>
              <p>{{ 'REPORT.EVALUALIA.TYPEWRITING.RESUME3' | translate }}</p>
          </div>
        </div>

      </ng-container>


      <ng-container *ngIf="reportType == 'general'">
        <ng-container *ngIf="test.testModel.id !== 23">
          <div class="title-s mar-b-3">{{ 'REPORT.EVALUALIA.FINALSCORE' | translate }}:</div>
  
          <div id="cards" class="row mar-b-4 title-xs">
            <div class="col-4 pad-x-1">
              <div class="card bg-color-tertiary color-white h-100">
                <div class="card-body pad-1">
                  <p>
                    <span>{{ 'REPORT.EVALUALIA.SUCCESSTITLE1' | translate }}</span><br>
                    <span class="color-senary">{{ test.result.score }}%</span><br>
                    <span>{{ 'REPORT.EVALUALIA.SUCCESSTITLE2' | translate }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-4 pad-x-1">
              <div class="card bg-color-tertiary color-white h-100">
                <div class="card-body pad-1">
                  <p>
                    <span>{{ 'REPORT.EVALUALIA.LEVELACHIEVED' | translate }}</span><br>
                    <span class="color-senary">{{ test.result.levelAchieved }} <span class="color-white">{{ 'COMMON.OF' | translate }}</span> {{ test.result.maxLevel }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-4 pad-x-1">
              <div class="card bg-color-tertiary color-white h-100">
                <div class="card-body pad-1">
                  <p>
                    <span>{{ 'REPORT.EVALUALIA.YOURFINALSCORE' | translate }} </span>
                    <span>{{ 'REPORT.EVALUALIA.BELONGSGROUP1' | translate }} </span>
                    <span class="color-senary">{{ (test.result.levelAchievedResume||test.result.levelAchievedDetail) | lowercase }} </span>
                    <span>{{ 'REPORT.EVALUALIA.BELONGSGROUP2' | translate }} </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Solo para la prueba excel ejercicos de amazon -->
        <div *ngIf="test.testModel.id === 23">
          <p class="title-s mar-b-2">{{ 'REPORT.EVALUALIA.FINALSCORE' | translate }}:</p>
          <p class="title-xs mar-b-0 color-tertiary" *ngIf="test.testModel.id === 23">{{ 'REPORT.EVALUALIA.SUCCESSTITLE1' | translate }} {{ test.result.score }}%.</p>
        </div>

        <p [class]="test.testModel.id === 23 ? 'title-xs color-tertiary mar-b-4' : 'mar-b-4'">{{ 'REPORT.EVALUALIA.LEVELCOMPLETED' | translate:{ a: test.result.timeSpent, b: test.result.completionPercentage } }}</p>   
      
        <div class="row">
          <div class="col-7 mar-b-4">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.AREASCORE' | translate }}:</div>

            <ng-container *ngIf="reportType === 'general'">
              <table id="areasTable" class="table">
                <thead>
                  <tr class="color-tertiary">
                    <td></td>
                    <td>{{ 'REPORT.EVALUALIA.SUCCESS' | translate }}</td>
                    <td>{{ 'REPORT.EVALUALIA.TIME' | translate }}</td>
                    <td>{{ 'REPORT.EVALUALIA.ANSWERED' | translate }}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let area of test.areas">
                    <td>{{ area.description }}</td>
                    <td>{{ area.score }}%</td>
                    <td>{{ area.time }}{{ ( test.testModel.id !== 23 ? 'REPORT.EVALUALIA.TIMEABBREVIATIONRESULT' : 'REPORT.EVALUALIA.TIMEABBREVIATION' ) | translate }}</td>
                    <td>{{ area.answered }}%</td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
          <div id="results" class="col-12">
            <div class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.RESULTSREPORT' | translate }}:</div>
              <p>{{ test.result.scoreDetail }}</p>
              <p [innerHTML]="test.result.areaScoreDetail"></p>
          </div>
        </div>
      </ng-container>
      
    </div>

    <ct-last-page-report [colors]="colors" [test]="test"></ct-last-page-report>
  </div>
</div>

<button class="btn btn-primary pdf_button" (click)="print()">{{ 'COMMON.GENERATEPDF' | translate }}</button>

<pre id="base64" hidden></pre>
